import type { MyBetLeg } from '@ps/isp-web-services-types';
import type { Currency } from '@ps/web-core-enums';
import React from 'react';

import Part from './components/Part/Part';

export interface Props extends MyBetLeg {
  isSettled?: boolean;
  currency: Currency;
  cashedOutAmount?: number;
  betId?: string;
}

const Leg: React.FC<Props> = ({ betId, parts, result, isSettled, currency, cashedOutAmount }) => (
  <>
    {parts.map((part, index) => (
      <Part
        betId={betId}
        key={index}
        part={part}
        result={result}
        isSettled={isSettled}
        currency={currency}
        cashedOutAmount={cashedOutAmount}
      />
    ))}
  </>
);

export default Leg;
